import React, { useEffect, useState } from 'react';
import { Menu } from "antd";
import { Link } from 'react-router-dom';
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
// import ContextMenu from "./ContextMenu";

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'
import { useAuth } from "../../authentication";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { authUser } = useAuth();

  const [isShow, setIsShow] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [mouseEvent, setMouseEvent] = useState(null);

  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];

  const history = useHistory()

  const onClick = (MenuItem) => {
    setIsShow(false);
    history.push(MenuItem.key)
  }

  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  function onContextMenu(e, menuItem) {
    setIsShow(true);
    setMouseEvent(e);
    setSelectedMenuItem(menuItem);
    e.preventDefault();
    return false;
  }

  const items: MenuItem[] = [];
  authUser.ClientMenuList.forEach(menu => {
    let child = null;

    if (menu.ChildClientMenuList !== null) {
      child = [];
      menu.ChildClientMenuList.forEach(childMenu => {
        // child.push(getItem(<span>{childMenu.Key}</span>, childMenu.Url));
        child.push(getItem(<Link to={{ pathname: childMenu.Url, key: childMenu.Key }}>{childMenu.Key}</Link>, childMenu.Url));
      });
    }

    if (child !== null) {
      items.push(getItem(<span>{menu.Key}</span>, menu.Url, <i className={menu.Icon} />, child));
    } else {
      items.push(getItem(<Link to={{ pathname: menu.Url, key: menu.Key }}>{menu.Key}</Link>, menu.Url, <i className={menu.Icon} />, child));
    }
  });

  let check = false;
  authUser.ClientMenuList.forEach(menu => {
    if (menu.ChildClientMenuList !== null) {
      menu.ChildClientMenuList.forEach(childMenu => {
        if (history.location.pathname + history.location.search === childMenu.Url) {
          document.title = childMenu.Key;
          check = true;
        }
      });
    }

    if (history.location.pathname === menu.Url) {
      document.title = menu.Key;
      check = true;
    }
  });

  console.log(history.location.pathname + history.location.search);
  //一些不在menu里的特殊url的判断
  let path = [];
  path.push('/jobs?keyword=');
  path.push('/job/lodge?module=');
  path.push('/job/new');
  path.push('/job/detail');
  path.push('/my-profile');
  path.push('/admin/job-template-detail');
  path.push('/error');

  path.map(item => {
    if ((history.location.pathname + history.location.search).indexOf(item) === 0) {
      check = true;
    }
  })

  if (!check) {
    history.push('/jobs');
  }

  return (
    <>
      {/* <ContextMenu isShow={isShow} menuItem={selectedMenuItem} mouseEvent={mouseEvent} setIsShow={setIsShow} /> */}
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
            items={items}
            onClick={onClick}
          >
            {/* {
              items.map((menu, i) => {
                if (menu.children != null) {
                  return <Menu.SubMenu key={i} icon={menu.icon} title={menu.label} onContextMenu={(e: any) => { e.preventDefault(); return false; }}>
                    {
                      menu.children.map((childMenu, j) => {
                        return <Menu.Item key={i + '_' + j} icon={childMenu.icon} key={childMenu.key} onContextMenu={(e: any) => { onContextMenu(e, childMenu) }}>{childMenu.label}</Menu.Item>
                      })
                    }
                  </Menu.SubMenu>
                } else {
                  return <Menu.Item key={i} icon={menu.icon} key={menu.key} onContextMenu={(e: any) => { onContextMenu(e, menu) }}>{menu.label}</Menu.Item>
                }
              })
            } */}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
